// Components
import { FormElems, Overlay } from '../../components/';
import { validators } from '../../utils/validators';

// Actions
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import { fetchLinkIdForPreFilledFileRequest } from './redux/BulkPaymentLink.actions';

// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};

    if (REQUIRED(values.linkName)) {
        errors.linkName = 'Please enter link name';
    }

    if (REQUIRED(values.linkId)) {
        errors.linkId = 'Please enter link ID';
    }

    return errors;
};

const DownloadPreFilledFileFilter = ({
    showOverlay,
    closeFilter,
    handleSubmit,
    actions,
}) => {
    const handleFormSubmit = values => {
        actions.fetchLinkIdForPreFilledFileRequest(values);
    };

    return (
        <>
            <div className="preFilledFileFilterWrap">
                <>
                    {showOverlay ? (
                        <Overlay closeFilter={closeFilter} isTransparent />
                    ) : null}
                    <div className="preFilledFileFilter">
                        <div className="tableFilter-bulkUpload">
                            <form
                                className="filter-form"
                                onSubmit={handleSubmit(handleFormSubmit)}
                            >
                                <div className="form-field">
                                    <p className="label">Link ID</p>
                                    <Field
                                        name="linkId"
                                        type="text"
                                        placeholder="Enter Link Id"
                                        component={FormElems.Input}
                                    />
                                </div>
                                <div className="form-field">
                                    <p className="label filterTitle">
                                        Link Name
                                    </p>
                                    <Field
                                        name="linkName"
                                        type="text"
                                        placeholder="Enter Link Name"
                                        component={FormElems.Input}
                                    />
                                </div>
                                <div className="form-field actions">
                                    <FormElems.Button
                                        buttonType="primary"
                                        text="DOWNLOAD"
                                        id="submit-button"
                                        handleClick={handleSubmit(
                                            handleFormSubmit
                                        )}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            </div>
        </>
    );
};

DownloadPreFilledFileFilter.propTypes = {
    showOverlay: PropTypes.bool,
    closeFilter: PropTypes.func,
    handleSubmit: PropTypes.func,
    userLevel: PropTypes.string,
    staticData: PropTypes.object,
    actions: PropTypes.object,
    auth: PropTypes.object,
};

const mapStateToProps = ({ auth, form, staticData }) => ({
    auth,
    formData: form['pre-filled-filter-payment-link'],
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            fetchLinkIdForPreFilledFileRequest,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'pre-filled-filter-payment-link',
        enableReinitialize: true,
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(DownloadPreFilledFileFilter);
